import setValueFromServer from "./setValueFromServer";
import updatedCourse from "./updatedCourse";

export default [setValueFromServer, updatedCourse];
